import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import { Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { FC } from 'react';
import { DotsLoading } from '../DotsLoading';

interface PaymentLoadingModelProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  listAirline: string[]
}

const PaymentLoadingModel: FC<PaymentLoadingModelProps> = ({ open, listAirline, setOpen }) => (
  <div>
    <Dialog
      open={open}
      onClose={() => { setOpen(false); }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '12px',
          margin: '16px',
          boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <Stack
        spacing={pr`12px`}
        sx={{ p: pr`16px` }}
        // textAlign="center"
      >
        <img
          src="https://storage.googleapis.com/goyolo-production/choose.png"
          alt="logo"
          className="lazyload"
          style={{
            // width: '150px',
            objectFit: 'contain',
          }}
        />
        <Typography
          textAlign="center"
          variant="title"
        >
          Goyolo đang giữ chỗ cho bạn
        </Typography>
        <Typography variant="body2">
          Thời gian để
          {' '}
          {listAirline.join(', ')}
          {' '}
          xử lý đặt chỗ mất khoảng 1 phút. Sau khi hãng bay
          hoàn tất đặt chỗ, hệ thống sẽ tự động chuyển bạn sang màn hình thanh
          toán.
          <br />
          <br />
          Mong bạn thông cảm không tắt màn hình này.
        </Typography>
        <Stack
          justifyContent="center"
          alignItems="center"
        >
          <DotsLoading
            color={style.color.product3}
            height={60}
            width={60}
          />

        </Stack>
      </Stack>
    </Dialog>
  </div>
);

export default PaymentLoadingModel;
